module.exports = __webpack_public_path__ + "img/2.ef984471.jpg";